import '../scss/kbbui.scss';

export default function KbbTheme() {
    return null;
}
